import { EntityType, SensorDraft } from "../../../../../models";
import { ErrorActions } from "../../../../flux/Error";
import { Polyglot } from "../../../../../polyglot";
import { Command1, Command2 } from "../../../../../Command";

export class UpsertSensorCommand implements Command1<SensorDraft>
{
    private errorActions = new ErrorActions();
    
    constructor(private polyglot: Polyglot, private errorDispatchToken: string, private upsert: Command2<any, EntityType>)
    {        
    }

    execute = (draft: SensorDraft) => {
        const { VehicleId, GeotabId, SensorId, QuantityId } = draft;
        const setError = (msg: string) => this.errorActions.setError(new Error(msg), this.errorDispatchToken);

        if(typeof VehicleId !== 'number') {
            setError(this.polyglot.t('sensor.validation_err.vehicle_not_set'));
            return;
        }
        if(typeof GeotabId !== 'string' && typeof SensorId !== 'string') {
            setError(this.polyglot.t('sensor.validation_err.sensor_not_set'));
            return;
        }
        if(typeof QuantityId !== 'number') {
            setError(this.polyglot.t('sensor.validation_err.quantity_not_set'));
            return;
        }

        this.upsert.execute(draft, EntityType.Sensor);
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Sensor/commands/UpsertSensorCommand.ts